import React from 'react';
import PropTypes from 'prop-types';

import { nanoid } from 'nanoid'
import displayName from 'component-lib/displayName';

import {
    TableView,
    TableHeader,
    TableBody,
    TableRow,
    SortCell,
    TextCell,
} from 'v-c/TableView';

import ReportsListItem from 'v-c/Reports/ReportsListItem';

// TODO: this component doesn't use the static ui lib
export default function ReportsListTable(props) {
    const { getReportsMessage, reports } = props;
    const tableColumnMessage = cell => (
        getReportsMessage(`table.column.${cell}`)
    );

    return (
        <TableView tableId="reports-list">
            <TableHeader>
                <TableRow
                    rowId="header"
                    index={0}
                >
                    <SortCell
                        cellId="name"
                        text={tableColumnMessage('name')}
                        onClick={props.setSortColumn}
                        sortKey={props.sort.order}
                    />
                    <TextCell cellId="description">
                        {tableColumnMessage('description')}
                    </TextCell>
                    <TextCell cellId="status">
                        {tableColumnMessage('status')}
                    </TextCell>
                    <TextCell cellId="edit">
            &nbsp;
                    </TextCell>
                </TableRow>
            </TableHeader>
            <TableBody>
                {reports.map((report, i) => (
                    <ReportsListItem
                        attemptToEditReport={props.attemptToEditReport}
                        key={nanoid()}
                        index={i}
                        getReportsMessage={getReportsMessage}
                        report={report}
                        onToggle={props.onToggle(report)}
                    />
                ))}
            </TableBody>
        </TableView>
    );
}

ReportsListTable.displayName = displayName('Reports/ReportsListTable');

ReportsListTable.propTypes = {
    attemptToEditReport: PropTypes.func.isRequired,
    getReportsMessage: PropTypes.func.isRequired,
    reports: PropTypes.array.isRequired,
    onToggle: PropTypes.func.isRequired,
    setSortColumn: PropTypes.func.isRequired,
    sort: PropTypes.object.isRequired,
};
